import { render, staticRenderFns } from "./NarliFerryboatStatsByPlateView.vue?vue&type=template&id=2432f99c&"
import script from "./NarliFerryboatStatsByPlateView.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByPlateView.vue?vue&type=script&lang=js&"
import style0 from "./NarliFerryboatStatsByPlateView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports